










































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import {
  User,
  Worker,
  isWorker,
  Relative,
  isRelative,
  PatientInRelative
} from '@/types/user'

@Component({
  components: {
    CheckboxInput: () => import('@/components/common/StyledCheckboxInput.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MessageWorkerRelativeList extends Vue {
  $store!: ExStore
  isLoading = true
  allCheck = false

  async beforeCreate() {
    await this.$store.dispatch('team/updatePatients')
    await this.$store.dispatch('relative/updateList')
    this.isLoading = false
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get relativeInfo() {
    return this.$store.getters['user/relativeInfo']
  }

  get workers() {
    return this.$store.getters['team/workersForPatientUser']
  }

  get isRelative() {
    return this.user.isPatientRelative
  }

  get relatives() {
    if (this.user.isPatientRelative) return []
    return this.$store.getters['relative/activeRelativeList']
  }

  get recipients() {
    return this.$store.getters['message/recipients']
  }

  isRecipient(user: Worker | Relative) {
    return this.recipients.find(recipient => recipient.id === user.id)
  }

  getUserName(user: User) {
    return `${user.lastName}${user.firstName}`
  }

  getOccupationName(user: Worker | Relative) {
    if (isRelative(user)) return '家族'
    return user.occupation ? user.occupation.name : ''
  }

  handleCheck(checked: boolean, user: Worker | Relative | PatientInRelative) {
    const action = checked
      ? 'message/addRecipients'
      : 'message/removeRecipients'
    this.$store.dispatch(action, [user])
    if (this.allCheck && !checked) this.allCheck = false
  }

  handleAllCheck(checked: boolean) {
    if (this.workers.length && this.relatives.length) return
    const recipents = checked ? this.workers : []
    this.$store.dispatch('message/updateRecipients', recipents)
  }

  checkDisable(user: Worker | Relative) {
    const relative = this.recipients.find(r => isRelative(r))
    const worker = this.recipients.find(r => isWorker(r))
    if (relative && isWorker(user)) return true
    if (worker && isRelative(user)) return true
    return false
  }
}
